import React from 'react';
import { StyleSheet, View } from 'react-native';

import { RightArrow } from '@/assets/icons/right-arrow';
import { Text } from '@/components/TextComponent';
import { TouchableBox } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { common } from '@/styles/styles';

import { carouselItemHeight, itemSeparatorWidth } from './Carousel';

interface ViewAllPromoCardProps {
    onPress: () => void;
}

export const ViewAllPromoCard = ({ onPress }: ViewAllPromoCardProps) => {
    return (
        <TouchableBox
            onPress={onPress}
            style={styles.container}
            borderRadius={'r16'}
            backgroundColor={ds.colorToken.background.neutral.subtler}
            borderWidth={1}
            borderColor={ds.colorToken.border.strong}
            justifyContent={'center'}
            alignItems={'center'}
        >
            <View style={styles.arrow}>
                <RightArrow />
            </View>
            <Text variant={'labelMedium'} color={ds.colorToken.text.primary} mt={'s8'}>
                View all
            </Text>
        </TouchableBox>
    );
};

const styles = StyleSheet.create({
    container: {
        ...common.shadow,
        height: carouselItemHeight,
        marginLeft: itemSeparatorWidth,
        width: 84,
    },
    arrow: {
        marginTop: 4,
        height: 36,
        width: 36,
        borderRadius: 100,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: ds.colorValue.background.neutral.strong,
    },
});
